


export default {
  title: '联系我们',
  subTitle1: '总公司',
  subTitle2: '无锡凯尔克仪表阀门有限公司',
  contactTxt: '24小时服务热线',
  qrcodeLabel: '请扫二维码联系或关注：<span style="font-weight:normal">欢迎进入无锡凯尔克智能服务平台发起会话，或通过PC端或微信小程序在线留言</span>',
  info_list: [
    {
      label: "联系人员：",
      content: "杜经理"
    },
    {
      label: "联系邮件：",
      content: "info@kelkflow.com.cn"
    },
    {
      label: "联系电话：",
      content: "+86-(0)510-85141699"
    },
    {
      label: "",
      content: `
        <div style="color: #00335a;margin-top:-10px;">
          (工作时间：周一至周五，上午8:00 - 下午4:30)
        </div>
      `
    },
    {
      label: "办公地址：",
      content: "中国江苏省无锡市新吴区鸿山镇后宅德育路6号（214115）"
    },
    /* {
      label: "邮政编码：",
      content: "214115"
    }, */
    // {
    //   label: "服务邮件：",
    //   content: "services@kelkflow.com.cn"
    // }
  ],
  qrcodeList: [
    [
      {
        icon: require("@/assets/images/callMe/1.png"),
        selectIcon: require("@/assets/images/callMe/1-1.png"),
        qr_code: require("@/assets/images/public/img1.png"),
        value: "微信公众号",
        seen: false
      },
      {
        icon: require("@/assets/images/callMe/2.png"),
        selectIcon: require("@/assets/images/callMe/2-2.png"),
        qr_code: require("@/assets/images/public/img3.png"),
        value: "小程序",
        seen: false
      },
      {
        icon: require("@/assets/images/callMe/3.png"),
        selectIcon: require("@/assets/images/callMe/3-3.png"),
        qr_code: require("@/assets/images/public/img2.png"),
        value: "视频号",
        seen: false
      },
    ],
    [
      {
        icon: require("@/assets/images/callMe/4.png"),
        selectIcon: require("@/assets/images/callMe/4-4.png"),
        qr_code: require("@/assets/images/public/img4.png"),
        value: "微信",
        seen: false
      },
      {
        icon: require("@/assets/images/callMe/6.png"),
        selectIcon: require("@/assets/images/callMe/6-6.png"),
        qr_code: require("@/assets/images/public/img5.png"),
        value: "企业微信",
        seen: false
      },
      {
        icon: require("@/assets/images/callMe/5.png"),
        selectIcon: require("@/assets/images/callMe/5-5.png"),
        qr_code: require("@/assets/images/public/img6.png"),
        value: "微信客服",
        seen: false
      }
    ]
  ],
  form: {
    title: '在线留言',
    // sign:`您可扫描左侧专属入口，进入凯尔克智能服务平台发起会话；或通过PC端或微信小程序端提交需求。我们的服务网络将启动极速响应机制，2小时内由专属工程师对接，以全链路解决方案赋能您的工业智造升级`,
    // tipSign: '(工作时间：周一至周五，上午8:00 - 下午4:30)',
    usernameLabel: '姓名',
    businessLabel: '公司',
    telPhoneLabel: '联系电话',
    emailLabel: '邮箱',
    emailCodeLabel: '邮箱验证码',
    dutiesLabel: '职务',
    uploadLabel: '附件',
    uploadPlaceholder: '上传附件',
    leaveContentPlaceholder: '请输入内容',
    submitBtn: '提交'
  },
  group1: [
    {
      title: 'KELK 全球网络',
      content: '无锡凯尔克以无锡总部为核心，辐射华东、华南、华北等六大区域，构建覆盖全国30个省市的本地化服务网络。300+专业工程师团队与50个备件仓联动，承诺8小时抵达国内任一客户现场，提供从售前选型咨询、安装调试到故障排查的全周期服务。依托数字化远程诊断系统与标准化服务流程，实现7×24小时快速响应，年均解决紧急问题超2000例，以“零距离”服务缩短客户停机时间，为工业控流安全保驾护航',
      button: '查看网络',
      path: '/about'
    },
    {
      title: '加入 KELK',
      content: `在精密控制阀与工业流体技术的星辰大海中，人才是凯尔克锚定创新、问鼎全球的引擎。作为中加技术融合的标杆企业，我们深知：每一台打破进口垄断的低温深冷阀、每一套服务国家级能源工程的智能控流系统，都源自一支敢闯技术无人区的精英团队`,
      button: '加入我们',
      path: '/joinIn'
    }
  ],
  varificationCode: {
    title: '验证您的邮箱地址',
    desc1: `
      由于这是您在网站内的第一次留言，我们已向您的邮箱<strong style="color:#333;">$email</strong>发送了一条具有您唯一的 $length 位数代码的短信，有效期为 15 分钟，请注意查收。<br />
      (<span style="font-size:1.0625rem;color:#063358">如果未接收到邮件，请检查邮箱地址输入是否正确，或请查看邮箱内的垃圾邮箱，如果依然未收到验证码，请拨打电话 <strong>+86-18961832100</strong> 或发送邮件到 <strong>info@kelkflow.com.cn</strong> 进行咨询</span>)
    `,
    desc2: `请在下面输入代码以确认您的邮箱地址`,
    btnTxt1: '获取新的验证码',
    btnTxt2: '获取中...',
    closeBtn: '关 闭',
    confirmBtn: '提 交',
    getErrorTip1: '获取失败，邮箱地址不能为空',
    getErrorTip2: '获取失败，请检查后重新获取！',
    getSuccessTip: '验证码已发送,请前往邮箱查看',
  },
  messageDetailsTxt: '留言详情',

  messageSuccessModal: {
    title: '在线留言',
    closeBtn: '关 闭',
    confirmBtn: '查看留言',
    desc1: `如果您有问题需要咨询，我们的专家可以帮助您。请在 "联系我们"
          中，留下您的问题。如果您已经有了咨询编号并且想要了解进度，请点击
          <a style="color:#00a4ff;text-decoration:underline;" href="#/message-record">査看留言</a>，其他问题也可以联系
          <strong>051088582008</strong> 或发邮件至
          <strong>info@kelkflow.com.cn</strong>`,
    desc2: `
    感谢您的咨询！一封电子邮件确认信已发送至您的电子邮件帐户，并附有您的咨询详情链接。KELK
          专家将在第一时间内回复您的问题，您可以点击电子邮件中的问题链接以查看该咨询的最新状态。或者如果您有需要，也可以联系我们的客户服务部门获取有关此咨询的更多信息。您的咨询
          ID 号为
          <strong>$m_no</strong>
    `
  }
}


// WEBPACK FOOTER //
// ./src/config/lang/zh-CN/contactUs.js